import { pxArrayToRem, pxToRem, type StyleRule } from '@archipro-design/aria';

// `columns` is still accepted so the callers keep their existing shape, but the
// span no longer derives from it — see the note on gridColumn below.
export const MoreProductComing: StyleRule<{ columns: number }> = ({
    theme,
}) => ({
    // Span every column rather than a computed count: the grids that host this
    // clamp 5 and 6 columns down to 4 between md and lg, so a computed span
    // overshot the rendered grid there and created implicit tracks.
    gridColumn: '1 / -1',
    borderTop: '1px solid #1a1919',
    padding: pxArrayToRem([15, 0]),

    [theme.screen.laptop]: {
        padding: pxArrayToRem([51, 0]),
    },
});

export const Message: StyleRule = ({ theme }) => ({
    lineHeight: pxToRem(17),
    color: 'rgba(110, 110, 113, 0.93)',
    paddingTop: theme.siteVariables.spaces['space-16'],
    '& u': {
        cursor: 'pointer',
    },
    [theme.screen.laptop]: {
        paddingTop: theme.siteVariables.spaces['space-24'],
        color: theme.siteVariables.colors.charcoal[250],
        lineHeight: pxToRem(19.2),
    },
});
